import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { actionsKeys } from '../components/question_menu/conditionalActions/conditionalAction.utils';

export const mockQuestionTypes = [
  {
    icon: 'done',
    name: 'Test',
    allowExternal: true,
  },
  {
    icon: 'text_fields',
    name: 'Text',
    observationType: 'true',
    allowExternal: true,
  },
  {
    icon: '123',
    name: 'Number',
    allowExternal: true,
  },
  {
    icon: 'photo_camera',
    name: 'Image',
  },
  { icon: 'account_box', name: 'User' },
  {
    icon: 'library_add_check',
    name: 'Select',
    observationType: 'true',
    allowExternal: true,
  },
  { icon: 'table_view', name: 'Table' },
  { icon: 'border_color', name: 'Signature' },
  {
    icon: 'calendar_month',
    name: 'Date',
    observationType: 'true',
    allowExternal: true,
  },
  { icon: 'apps', name: 'Matrix' },
  { icon: 'upload_file', name: 'File' },
  { icon: 'mic', name: 'Audio' },
  { icon: 'local_shipping', name: 'Asset' },
  { icon: 'arrow_drop_down_circle', name: 'Dropdown' },
  { icon: 'add_location_alt', name: 'GPS' },
  { icon: 'message', name: 'Message' },
];

export const testQuestionOptions = [
  'Pass, Fail, N/A',
  'Pass, Fail',
  'Yes, No, N/A',
  'Yes, No',
  'OK, Issue',
  'OK, Issue, N/A',
  'Acceptable, Unacceptable, N/A',
];

export const statusType = {
  none: 'NONE',
  pass: 'PASS',
  fail: 'FAIL',
  notApplicable: 'NOT_APPLICABLE',
};

export const inputTypes = {
  image: 'IMAGE',
  number: 'NUMBER',
  test: 'TEST',
  text: 'TEXT',
  table: 'TABLE',
  user: 'USER',
  select: 'SELECT_SINGLE',
  multiSelect: 'SELECT_MULTI',
  signature: 'SIGNATURE_SINGLE',
  multiSignature: 'SIGNATURE_MULTI',
  date: 'DATE',
  matrix: 'MATRIX',
  multiText: 'TEXT_MULTI',
  multiFile: 'FILE_MULTI',
  file: 'FILE_SINGLE',
  multiImage: 'IMAGE_MULTI',
  multiUser: 'USER_MULTI',
  dateTime: 'DATE_TIME',
  time: 'TIME',
  audio: 'AUDIO',
  asset: 'ASSET',
  dropdownSingle: 'DROPDOWN_SINGLE',
  dropdownMulti: 'DROPDOWN_MULTI',
  selectChecklist: 'SELECT_CHECKLIST',
  gps: 'GPS',
  message: 'MESSAGE',
  riskRegistry: 'RISK_REGISTRY',
};

export const getExtension = (url) => {
  const urlParts = url?.split('.');
  return url ? urlParts[urlParts?.length - 1] : null;
};

export const internalTemplateMEETING = (
  description,
  safetyTopic,
  location,
) => ({
  'Meeting Description': { value: description },
  'Safety Topic': { value: safetyTopic },
  Location: { value: location },
});

//added Apr 22 2025 - Updates to meetings make some of this auto template unnecessary.
// Probs could be fixed with a migration but I don't want to do that since theres legacy
// values so here we are - and we would have to revise the template through SQL
export const hideLegacyMeetingFields = [
  'External Participants',
  'Meeting Transcription',
  'Meeting Recording',
  'Attachment',
];

export const dateOptions = {
  DATE: {
    title: 'Date',
    format: 'YYYY-MM-DD',
    views: ['year', 'month', 'day'],
  },
  DATE_TIME: {
    title: 'Date and Time',
    format: 'YYYY-MM-DD h:mm A',
    views: ['day', 'hours', 'minutes', 'month', 'year'],
    timeSteps: { hours: 1, minutes: 1 },
  },
  TIME: {
    title: 'Time',
    format: 'h:mm a',
    timeSteps: { hours: 1, minutes: 1 },
  },
};

export const downloadFile = (url, name) => {
  fetch(url)
    .then((response) => response.blob())
    .then((blob) => {
      const objectUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      const awsExtension = new URL(url).pathname
        ?.split('/')
        .pop()
        ?.split('.')
        .pop();
      if (name?.split('.').length > 1) {
        link.download = name;
      } else {
        link.download = name + '.' + awsExtension;
      }
      link.href = objectUrl;
      link.click();
      URL.revokeObjectURL(objectUrl);
    })
    .catch((error) => console.error(error));
};

export const formatBundleItems = (items) => {
  const bundleMap = {};
  const itemMap = {};

  (items || []).forEach((item) => {
    if (item?.bundleId) {
      bundleMap[item.categoryId] = bundleMap[item.categoryId]
        ? bundleMap[item.categoryId]
        : {};

      bundleMap[item.categoryId][item.bundleId] = bundleMap[item.categoryId][
        item?.bundleId
      ]
        ? bundleMap[item.categoryId][item?.bundleId]
        : {};

      bundleMap[item.categoryId][item.bundleId][item.questionId] = item;
      if (!itemMap[item.questionId]) {
        itemMap[item?.questionId] = [item];
      } else {
        itemMap[item?.questionId]?.push(item);
      }
    } else {
      itemMap[item?.questionId] = item;
    }
  });

  return { bundleMap, itemMap };
};
export function numberCheck(additionalData) {
  const [min, max] = additionalData?.split('|') || [];
  const minValue =
    min !== undefined && min !== null && min !== '' && !isNaN(min)
      ? parseFloat(min)
      : null;
  const maxValue =
    max !== undefined && max !== null && max !== '' && !isNaN(max)
      ? parseFloat(max)
      : null;
  let string;

  if (minValue !== null && maxValue !== null) {
    string = `Tolerance: ${minValue}-${maxValue}`;
  } else if (minValue !== null) {
    string = `Min: ${minValue}`;
  } else if (maxValue !== null) {
    string = `Max: ${maxValue}`;
  } else {
    string = '';
  }

  return string;
}

const dynamicOperatorMap = {
  EQUALS: (a, b) => a === b,
  NOT_EQUALS: (a, b) => a !== b,
  LESS_THAN: (a, b) => a < b,
  LESS_EQUALS: (a, b) => a <= b,
  GREATER_THAN: (a, b) => a > b,
  GREATER_EQUALS: (a, b) => a >= b,
  OR: (a, b) => {
    const valueArray = a.split('|');
    const compareArray = b.split('|');

    let hasOne = false;

    for (const value of compareArray) {
      if (valueArray.includes(value)) {
        hasOne = true;
      }
    }

    return hasOne;
  },
  AND: (a, b) => {
    const valueArray = a.split('|');
    const compareArray = b.split('|');

    return compareArray.every((value) => valueArray.includes(value));
  },
};

export const dateTimeTypes = ['DATE', 'TIME', 'DATE_TIME'];

const multiValueInputTypes = [
  'SELECT_MULTI',
  'USER_MULTI',
  'DROPDOWN_MULTI',
  'SELECT_CHECKLIST',
];

const toSortedSet = (pipeDelimitedStr) =>
  [...new Set(pipeDelimitedStr.split('|'))]
    .sort((a, b) => a.localeCompare(b))
    .join('|');

const evaluateSingleCondition = (
  answer,
  inputType,
  { value: preDeterminedValue, operator },
) => {
  if (!operator || !answer || !preDeterminedValue) return false;
  const operation = dynamicOperatorMap[operator];

  if (!operation) {
    throw new Error(`Invalid operator: ${operator}`);
  }

  if (dateTimeTypes.includes(inputType)) {
    const dateAnswer = moment(answer).valueOf();
    const currentYear = moment().year();
    let dateValue;

    if (preDeterminedValue === 'TODAY') {
      dateValue = moment().startOf('day').valueOf();
    } else {
      dateValue = moment(`${currentYear}-${preDeterminedValue}`).valueOf();
    }

    if (
      inputType === 'DATE_TIME' &&
      preDeterminedValue?.split(' ')[0] === 'TODAY'
    ) {
      const hours = preDeterminedValue?.split(' ')[1].split(':')[0];
      const minutes = preDeterminedValue?.split(' ')[1].split(':')[1];
      dateValue = moment().startOf('day').set({ hours, minutes }).valueOf();
    }

    if (inputType === 'TIME') {
      const dateAnswer = moment(answer, 'hh:mm a').valueOf();
      const dateValue = moment(preDeterminedValue, 'HH:mm').valueOf();
      return operation(dateAnswer, dateValue);
    }

    return operation(dateAnswer, dateValue);
  }

  if (!isNaN(answer)) {
    return operation(answer, preDeterminedValue);
  }

  const capitalizedAnswer = answer?.toUpperCase();
  const capitalizedPreDeterminedValue = preDeterminedValue?.toUpperCase();

  if (
    multiValueInputTypes.includes(inputType) &&
    (operator === 'EQUALS' || operator === 'NOT_EQUALS')
  ) {
    return operation(
      toSortedSet(capitalizedAnswer),
      toSortedSet(capitalizedPreDeterminedValue),
    );
  }

  return operation(capitalizedAnswer, capitalizedPreDeterminedValue);
};

export const evaluateCondition = (
  answer,
  { inputType = '', conditionalAction },
) => {
  if (Array.isArray(conditionalAction)) {
    return conditionalAction.some((ca) =>
      evaluateSingleCondition(answer, inputType, ca),
    );
  }
  return evaluateSingleCondition(answer, inputType, conditionalAction);
};

// Reverse-lookup of FOLLOW_UP_CATEGORY conditional actions across every
// question in a template, keyed by the target category id, since the
// trigger can live on a question in any category, not just the target's own.
export const getCategoryConditionalTriggers = (categories) => {
  const triggers = {};
  for (const category of categories || []) {
    for (const question of category.questions || []) {
      for (const logic of question.conditionalAction || []) {
        for (const conditionalActionItem of logic.actions || []) {
          if (conditionalActionItem.action !== actionsKeys.followUpCategory)
            continue;
          const targetId = conditionalActionItem.actionable?.id;
          if (!targetId) continue;
          if (!triggers[targetId]) triggers[targetId] = [];
          triggers[targetId].push({ question, logic });
        }
      }
    }
  }
  return triggers;
};

// A category with no triggers is always visible. A category with triggers
// is visible if any one of them evaluates true (OR semantics) against the
// current answers, keyed by questionId.
export const isCategoryVisible = (category, triggers, itemMap) => {
  const categoryTriggers = triggers?.[category.id];
  if (!categoryTriggers?.length) return true;
  return categoryTriggers.some(({ question, logic }) =>
    evaluateCondition(itemMap?.[question.id]?.value, {
      inputType: question.inputType,
      conditionalAction: logic,
    }),
  );
};

// Reverse-lookup of PREFILL_ANSWER conditional actions across a category's questions,
// keyed by the target QUESTION id — mirrors getCategoryConditionalTriggers above, but for
// individual questions instead of categories. Deliberately generic: it doesn't care what
// inputType the target question is, only that something targets it via PREFILL_ANSWER.
export const getPrefillTriggers = (categoryQuestions) => {
  const triggers = {};
  for (const question of categoryQuestions || []) {
    for (const logic of question.conditionalAction || []) {
      for (const action of logic.actions || []) {
        if (action.action !== actionsKeys.prefillAnswer) continue;
        const targetId = action.actionable?.id;
        if (!targetId) continue;
        if (!triggers[targetId]) triggers[targetId] = [];
        triggers[targetId].push({ question, logic, action });
      }
    }
  }
  return triggers;
};

// Collapses every currently-triggered PREFILL_ANSWER targeting a question into a single
// flat candidates list — this is what turns "N per-option ConditionalLogic rows" (one per
// dropdown option) into "1 array to render", regardless of how many options exist.
export const getPrefillCandidatesForQuestion = (
  targetQuestionId,
  triggers,
  itemMap,
) => {
  const questionTriggers = triggers?.[targetQuestionId];
  if (!questionTriggers?.length) return [];
  return questionTriggers
    .filter(({ question, logic }) =>
      evaluateCondition(itemMap?.[question.id]?.value, {
        inputType: question.inputType,
        conditionalAction: logic,
      }),
    )
    .map(({ question, logic, action }) => ({
      label:
        question.additionalData
          ?.split('|')
          ?.find((opt) => opt.toUpperCase() === logic.value) ?? logic.value,
      data: action.additionalData,
    }));
};

export const getFullAudioFile = async (fullAudioFileRef, addFileToS3) => {
  if (!fullAudioFileRef?.current || fullAudioFileRef.current.length === 0) {
    return null;
  }
  const blob = new Blob(fullAudioFileRef.current, { type: 'audio/webm' });
  const file = new File([blob], `meeting_audio_${Date.now()}.webm`, {
    type: 'audio/webm',
  });
  return new Promise((resolve, reject) => {
    addFileToS3({
      file,
      onSubmit: (fileObj) => resolve(fileObj?.url),
      onError: reject,
    });
  });
};

export function usePersistentUnclear(isSpeaking, isClearVoice, opts = {}) {
  const holdMs = opts.holdMs ?? 1500; // must be unclear for 1.5s to show
  const releaseMs = opts.releaseMs ?? 1000; // must be clear for 1s to hide

  const [unclearPersistent, setUnclearPersistent] = useState(false);
  const showTimerRef = useRef(null);
  const hideTimerRef = useRef(null);
  useEffect(() => {
    const bad = isSpeaking && !isClearVoice;

    if (bad) {
      if (hideTimerRef.current) {
        clearTimeout(hideTimerRef.current);
        hideTimerRef.current = null;
      }
      if (!unclearPersistent && !showTimerRef.current) {
        showTimerRef.current = setTimeout(() => {
          setUnclearPersistent(true);
          showTimerRef.current = null;
        }, holdMs);
      }
    } else {
      if (showTimerRef.current) {
        clearTimeout(showTimerRef.current);
        showTimerRef.current = null;
      }
      if (unclearPersistent && !hideTimerRef.current) {
        hideTimerRef.current = setTimeout(() => {
          setUnclearPersistent(false);
          hideTimerRef.current = null;
        }, releaseMs);
      }
    }

    return () => {};
  }, [isSpeaking, isClearVoice, holdMs, releaseMs, unclearPersistent]);

  return unclearPersistent;
}
